import { Button } from "@sellar-io/components";
import { DeliveryChargeFulfillmentType } from "@sellar-io/api-v2/types";
import { useForm } from "@tanstack/react-form";
import { useId } from "react";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import {
  ContainerTypeDeliveryChargeRulesForm,
  ContainerTypeDeliveryChargeRulesFormType,
} from "../forms/ContainerTypeDeliveryChargeRulesForm";
import { useContainerTypeDeliveryChargeRulesCreate } from "../../../../hooks/api/v2/containerTypeDeliveryChargeRules/useContainerTypeDeliveryChargeRulesCreate";
import { formatPriceInputToApi } from "../../../../hooks/usePriceFormat";

export const ContainerTypeDeliveryChargeRuleCreateDialog = ({
  active,
  onDismiss,
  fulfillmentType,
}: {
  active: boolean;
  onDismiss: () => void;
  fulfillmentType: DeliveryChargeFulfillmentType;
  fulfillmentTypeId?: number;
}) => {
  const formId = useId();

  const containerDeliveryChargeCreateMutation =
    useContainerTypeDeliveryChargeRulesCreate();

  const form = useForm({
    defaultValues: {
      value: "",
      containerType: "",
      deliveryCharge: 0,
    } satisfies ContainerTypeDeliveryChargeRulesFormType,
    onSubmit: ({ value }) => {
      const apiValue = formatPriceInputToApi(value.value);

      if (apiValue === null) throw new Error("apiValue should be defined");

      containerDeliveryChargeCreateMutation.mutate(
        {
          containerType: value.containerType,
          value: apiValue,
          fulfillmentType,
          deliveryCharge: 0,
        },
        {
          onSuccess: () => {
            onDismiss();
            form.reset();
          },
        },
      );
    },
  });

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Add free delivery rule"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        {containerDeliveryChargeCreateMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(containerDeliveryChargeCreateMutation.error)
                ?.response?.data.message ?? "Unknown error occurred."
            }
          />
        ) : null}
        <ContainerTypeDeliveryChargeRulesForm form={form} formId={formId} />
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={containerDeliveryChargeCreateMutation.isPending}
        >
          Add
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
